<template>
  <Dialog
    v-model:visible="visible"
    modal
    header="Connect to Closing Table"
    :style="{ width: '24rem' }"
  >
    <form class="flex flex-col gap-6" @submit.prevent="handleSubmit">
      <div class="flex flex-col items-center gap-2">
        <label for="table-code" class="text-navy-800 text-sm font-medium">
          Enter the code displayed on the table
        </label>
        <InputOtp v-model="code" :length="6" :disabled="loading" />
        <small v-if="error" class="text-xs text-red-600">
          {{ error }}
        </small>
      </div>

      <div class="flex justify-center gap-3">
        <AppButton type="button" variant="secondary" @click="close">
          Cancel
        </AppButton>
        <AppButton type="submit" :loading="loading" :disabled="code.length < 6">
          Connect
        </AppButton>
      </div>
    </form>
  </Dialog>
</template>

<script setup lang="ts">
import Dialog from "primevue/dialog"
import InputOtp from "primevue/inputotp"
import { ref, watch } from "vue"

import { apolloClient } from "../queries/client"
import CONNECT_TABLE from "../queries/order/connectTable.gql"
import AppButton from "./ui/AppButton.vue"

const props = defineProps<{
  orderId: string
}>()

const emit = defineEmits<{
  success: []
}>()

const visible = defineModel<boolean>("visible", { required: true })

const code = ref("")
const loading = ref(false)
const error = ref("")

watch(visible, (isVisible) => {
  if (isVisible) {
    code.value = ""
    error.value = ""
  }
})

const close = () => {
  visible.value = false
}

const handleSubmit = async () => {
  loading.value = true
  error.value = ""

  try {
    const result = await apolloClient.mutate({
      mutation: CONNECT_TABLE,
      variables: { orderId: props.orderId, code: code.value },
    })

    if (result?.data?.connectTableOrder?.errors?.length) {
      error.value = result.data.connectTableOrder.errors.join(", ")
      return
    }

    close()
    emit("success")
  } catch (e) {
    console.error("Mutation error:", e)
    error.value = "Something went wrong, please try again."
  } finally {
    loading.value = false
  }
}
</script>
